(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plush-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('plush-personalisation')) {
  customElements.define('plush-personalisation', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return; this.ready=true;
      const q=s=>this.querySelector(s), form=q('form'), dialog=q('dialog');
      const p=JSON.parse(q('[data-product]').textContent), labels=JSON.parse(q('[data-labels]').textContent);
      const options=p.options.map(o=>typeof o==='string'?o:o.name), index=options.indexOf('Personalisation');
      if(p.variants.length>100){q('[data-status]').textContent=labels.setup;return;}
      const selectList=[];
      const requestedSize=new URLSearchParams(location.search).get('pp_size');
      const initial=p.variants.find(v=>v.available && (index<0||v.options[index]==='None'))||p.variants[0];
      options.forEach((name,i)=>{
        if(i===index)return;
        const field=document.createElement('fieldset');field.className='product__variant-options product-form__input product-form__input--button';
        const legend=document.createElement('legend');legend.className='form__label';legend.textContent=name;field.append(legend);
        [...new Set(p.variants.map(v=>v.options[i]))].forEach((value,n)=>{
          const input=document.createElement('input'),label=document.createElement('label'),span=document.createElement('span');
          input.type='radio';input.name='pp-option-'+this.querySelector('form').id+'-'+i;input.value=value;input.id=input.name+'-'+n;
          input.className='product-option__input variant-option-radio-input visually-hidden';
          input.checked=value===((/size/i.test(name)&&requestedSize)?requestedSize:initial.options[i]);
          label.htmlFor=input.id;label.className='product-option__label product-option__label--square';span.textContent=value;label.append(span);field.append(input,label);
        });
        if(!field.querySelector(':checked'))field.querySelector('input').checked=true;
        q('[data-options]').append(field);
        selectList.push([i,{get value(){return field.querySelector(':checked').value;},addEventListener:(...args)=>field.addEventListener(...args)}]);
      });
      let saved=null, current=null;
      const max=Number(this.dataset.max)||15;
      const match=personalised=>p.variants.find(v=>(index<0?!personalised:v.options[index]===(personalised?'Personalised':'None')) && selectList.every(([i,s])=>v.options[i]===s.value));
      const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:labels.currency||'GBP'}).format(value/100);
      const update=()=>{
        current=match(!!saved);
        const standard=match(false), paid=match(true);
        const paired=standard && paid && paid.price>standard.price;
        const valid=!!current && current.available && (!saved||paired);
        q('[name=id]').disabled=!valid;q('[name=id]').value=current?.id||'';
        q('[data-buy]').disabled=!valid;q('[data-open]').disabled=false;
        q('[data-status]').textContent=saved&&!paired?labels.setup:(valid?'':labels.unavailable);
        q('[data-price]').textContent=current?money(current.price):(saved&&standard?money(standard.price+(labels.currency==='GBP'?3000:0)):'');
        q('[data-open]').textContent=(saved?labels.edit:labels.add)+(paired?' +'+money(paid.price-standard.price):(labels.currency==='GBP'?' +'+money(3000):''));
        q('[data-remove]').hidden=!saved;
        q('[data-summary]').textContent=saved?Object.values(saved).join(' · '):'';
        q('[data-properties]').replaceChildren();
        this.querySelectorAll('[data-pyjama-colour]').forEach(link=>{const url=new URL(link.href);const size=selectList.find(([i])=>/size/i.test(options[i]));if(size)url.searchParams.set('pp_size',size[1].value);link.href=url.href;});
        if(saved)Object.entries(saved).forEach(([key,value])=>{
          const input=document.createElement('input');input.type='hidden';input.name='properties['+key+']';input.value=value;q('[data-properties]').append(input);
        });
      };
      const fields={Text:q('[data-text]'),Placement:q('[data-placement]'),Font:q('[data-font]'),'Thread colour':q('[data-colour]')};
      Object.values(fields).forEach(el=>{if(el.tagName==='SELECT')Array.from(el.options).forEach(o=>{o.value=o.value.trim();o.textContent=o.textContent.trim();});});
      const colours={'Light Blue':'#93b7d0',Red:'#ad2428',Gold:'#9b7425',Navy:'#182b49','Chocolate Brown':'#56392e',White:'#fff'};
      const preview=()=>{
        q('[data-counter]').textContent=fields.Text.value.length+' / '+max;
        const el=q('[data-preview]');el.textContent=fields.Text.value;
        el.style.color=colours[fields['Thread colour'].value]||'#24211f';
        el.style.fontFamily={Script:'cursive',Block:'Arial, sans-serif',Romantic:'"PLUSH Romantic", cursive'}[fields.Font.value]||'Palatino, serif';
        q('[data-confirm]').checked=false;
      };
      Object.values(fields).forEach(el=>el.addEventListener('input',preview));
      selectList.forEach(([,s])=>s.addEventListener('change',update));
      q('[data-open]').addEventListener('click',()=>{
        Object.entries(fields).forEach(([key,el])=>{if(saved)el.value=saved[key];});
        preview();q('[data-error]').textContent='';dialog.showModal();fields.Text.focus();
      });
      q('[data-save]').addEventListener('click',()=>{
        const text=fields.Text.value;
        if(!text.trim()||text.length>max||! /^[A-Za-z0-9 .,'’&!/?()\-]+$/.test(text)||!q('[data-confirm]').checked){q('[data-error]').textContent=labels.invalid;return;}
        saved=Object.fromEntries(Object.entries(fields).map(([key,el])=>[key,el.value]));update();dialog.close();q('[data-open]').focus();
      });
      q('[data-close]').addEventListener('click',()=>dialog.close());
      q('[data-remove]').addEventListener('click',()=>{saved=null;update();});
      form.addEventListener('submit',event=>{
        if(dialog.open || !current?.available || q('[name=id]').disabled){event.preventDefault();return;}
        q('[data-buy]').disabled=true;
      });
      window.addEventListener('pageshow',update);
      update();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
